import * as React from "react";
import {
  DetailInnerWrapper,
  DetailPageBox,
} from "../../../components/sharedStyles";

import {
  OverviewTitle,
  OverviewTitleWrapper,
} from "../../../components/Details/OverviewInfo/styles";
import useActiveFilters from "../../../hooks/useActiveFilters";
import DocsList from "src/components/Tables/LeaseContracts/FullTableNewVersionDocs";
import { detailUrl } from "src/store/leaseContracts";
import { useHistory } from "react-router-dom";

export default function LeaseContractDocs() {
  const { filteredRealEstates } = useActiveFilters();
  const { push } = useHistory();

  const persistantQuery = {
    has_scrive: true,
    is_template: false,
    is_lease: true,
    realestate__in: filteredRealEstates,
  };

  return (
    <>
      <DetailInnerWrapper>
        <DetailPageBox>
          <OverviewTitleWrapper>
            <OverviewTitle>Digital signering av hyresavtal</OverviewTitle>
          </OverviewTitleWrapper>

          <DocsList
            onRowClicked={(obj) =>
              push(detailUrl({ id: obj.lease_contract?.id }))
            }
            persistantQuery={persistantQuery}
          />
        </DetailPageBox>
      </DetailInnerWrapper>
    </>
  );
}
